// Auto-generated router configuration
export default [
  {
    "path": "/404",
    "name": "404",
    component: () => import('@/view/404.vue')
  },
  {
    "path": "/finance",
    "name": "Finance",
    component: () => import('@/view/finance.vue')
  },
  {
    "path": "/financeEntry",
    "name": "FinanceEntry",
    component: () => import('@/view/financeEntry.vue')
  },
  {
    "path": "/",
    "name": "",
    component: () => import('@/view/index.vue')
  },
  {
    "path": "/introduce",
    "name": "Introduce",
    component: () => import('@/view/introduce.vue')
  },
  {
    "path": "/news",
    "name": "News",
    component: () => import('@/view/news.vue')
  },
  {
    "path": "/newsDetail",
    "name": "NewsDetail",
    component: () => import('@/view/newsDetail.vue')
  },
  {
    "path": "/scene",
    "name": "Scene",
    component: () => import('@/view/scene.vue')
  },
  {
    "path": "/help/index",
    "name": "HelpIndex",
    component: () => import('@/view/help/index.vue')
  },
  {
    "path": "/help/detail",
    "name": "HelpDetail",
    component: () => import('@/view/help/detail.vue')
  },
]